<template>
  <div>
    <v-card
      flat
      class="pa-2"
      :color="solo ? cardColor : 'transparent'"
      style="border: 1px solid #b8bcc0"
      outlined
    >
      <div class="text-h6 text-center grayText" v-if="solo">
        Add/Remove Search Fields
        <v-divider></v-divider>
      </div>
      <v-list shaped dense :color="solo ? cardColor : 'transparent'">
        <v-list-item-group v-model="localItems" multiple>
          <template v-for="(item, i) in formOptions">
            <v-list-item
              :key="`item-${i}`"
              :value="item.id"
              active-class="light-blue--text text--accent-4"
            >
              <template v-slot:default="{ active }">
                <v-list-item-action v-if="solo">
                  <v-icon small color="red" v-if="active"
                    >mdi-chevron-right</v-icon
                  >
                  <v-icon small color="green" v-else>mdi-chevron-left</v-icon>
                </v-list-item-action>
                <v-list-item-icon>
                  <v-icon v-if="item.icon" color="primary"
                    >mdi-{{ item.icon }}</v-icon
                  >
                  <v-img
                    v-else-if="item.image"
                    :src="iconSrc + item.image"
                    width="18"
                    class="mr-2 my-auto"
                    position="center center"
                  ></v-img>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    v-text="item.name"
                    class="ml-2"
                  ></v-list-item-title>
                </v-list-item-content>

                <v-list-item-action v-if="!solo">
                  <v-checkbox :input-value="active"></v-checkbox>
                </v-list-item-action>
              </template>
            </v-list-item>
          </template>
        </v-list-item-group>
      </v-list>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "ClAdvSearchFields",
  props: {
    wantedItems: [],
    formOptions: null,
    solo: null, // if true, put in card, show chevrons. If not it will show checkbox (assume displayed in dialog)
  },
  data: function () {
    return {
      localItems: [],
      iconSrc: "https://www.eyedock.com/images/menu_icons/",
      cardColor: "#f9fdff",
    };
  },
  methods: {},
  computed: {},
  watch: {
    localItems: {
      handler(val) {
        this.$emit("wantedItems", val);
      },
      deep: true,
    },
    wantedItems: {
      handler(val) {
        const areEqual = JSON.stringify(val) == JSON.stringify(this.localItems);
        //         val.every((element, index) => {
        //   return element === this.localItems[index];
        // });
        // console.log("items", val, this.localItems);
        // console.log("items equal? ", areEqual);
        if (!areEqual) this.localItems = val;
      },
      deep: true,
    },
  },
  mounted() {
    this.localItems = this.wantedItems;
  },
};
</script>

<style scoped></style>
